import {
  getPageInfoInitActions,
  getCommonSectionInitActions,
  getCustomInitActionsForWidgets,
} from './common';

import getAdoptabobblesWidgetConfigs from '../../components/Sections/AdoptabobblesSection/adoptabobblesWidgetConfigs';

export function getAdoptabobblesSectionInitActions(
  responseData,
  requestParams
) {
  return [
    ...getPageInfoInitActions(responseData, requestParams),
    ...getCommonSectionInitActions(
      responseData,
      requestParams,
      'adoptabobbles'
    ),
  ].filter(action => action);
}

export const getCustomInitActionsForAdoptabobblesWidgets = (
  responseData,
  requestParams
) => [
  ...getCustomInitActionsForWidgets(
    responseData,
    requestParams,
    getAdoptabobblesWidgetConfigs({ t: () => null, dispatch: () => null })
  ),
  ...getPageInfoInitActions(responseData, requestParams),
];
